import SoftTypography from "../../components/SoftTypography";
import { Link as RouterLink } from "react-router-dom";
import { Fragment } from "react";
import PropTypes from "prop-types";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

const BreadCrumbs = ({ pagesList, mb = 2 }) => {
  return (
    <SoftTypography component="div" aria-label="breadcrumb" mx={2} mb={mb} fontWeight="regular">
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => grey[600],
          },
        }}
      >
        <RouterLink to="/">
          <SoftTypography component="span" variant="body2" opacity={0.8}>
            <Icon>home</Icon>
          </SoftTypography>
        </RouterLink>

        {pagesList.map((page, index) => {
          const isLast = index === pagesList.length - 1;

          return (
            <Fragment key={index}>
              {!isLast ? (
                <RouterLink to={page.route} style={{ textDecoration: "none", color: "blue" }}>
                  <SoftTypography
                    component="span"
                    variant="subtitle2"
                    color="secondary"
                    fontWeight="regular"
                    fontSize="14px"
                    sx={{ "&:hover": { opacity: 1 } }}
                  >
                    {page.icon ? page.icon : null} {page.name}
                  </SoftTypography>
                </RouterLink>
              ) : (
                <SoftTypography
                  component="span"
                  variant="subtitle2"
                  opacity={1}
                  fontSize="14px"
                  color="dark"
                  fontWeight="regular"
                >
                  {page.icon ? page.icon : null} {page.name}
                </SoftTypography>
              )}
            </Fragment>
          );
        })}
      </MuiBreadcrumbs>

      {pagesList.length >= 1 && (
        <SoftTypography variant="h6" fontWeight="bold">
          {pagesList[pagesList.length - 1].name}
        </SoftTypography>
      )}
    </SoftTypography>
  );
};

BreadCrumbs.propTypes = {
  pagesList: PropTypes.array,
  mb: PropTypes.number,
};

export default BreadCrumbs;
